import { Typography } from "@fullscript/aviary-web";
import { faClipboardCheck, faShieldCheck, faTruckFast } from "@fullscript/pro-regular-svg-icons";
import { Trans, useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import { FeatureRow } from "./FeatureRow/FeatureRow";

import * as styles from "./QualityProgramSlide.styles";

const QualityProgramSlide = () => {
  const { t } = useTranslation();

  return (
    <div css={styles.slide}>
      <div css={styles.content}>
        <div css={styles.heading}>
          <Typography variant="h1" as="h2" intention="inverse" isMarginless>
            <Trans i18nKey={l.sideCarousel.slides.qualityProgram.title}>
              A higher standard <em css={styles.titleEmphasis}>for your health.</em>
            </Trans>
          </Typography>
          <Typography variant="footnote" intention="inverse" isMarginless>
            {t(l.sideCarousel.slides.qualityProgram.description)}
          </Typography>
        </div>
        <div css={styles.features}>
          <FeatureRow
            icon={faShieldCheck}
            title={t(l.sideCarousel.slides.qualityProgram.verifiedBrandsTitle)}
            description={t(l.sideCarousel.slides.qualityProgram.verifiedBrandsDescription)}
          />
          <FeatureRow
            icon={faClipboardCheck}
            title={t(l.sideCarousel.slides.qualityProgram.enhancedTestingTitle)}
            description={t(l.sideCarousel.slides.qualityProgram.enhancedTestingDescription)}
          />
          <FeatureRow
            icon={faTruckFast}
            title={t(l.sideCarousel.slides.qualityProgram.storedAndShippedTitle)}
            description={t(l.sideCarousel.slides.qualityProgram.storedAndShippedDescription)}
          />
        </div>
      </div>
    </div>
  );
};

export { QualityProgramSlide };
